import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/thankyou-videos")({
  component: lazyRouteComponent(() => import("./-pages/admin.thankyou-videos")),
  head: () => ({
    meta: [
      { title: "فيديوهات الشكر بعد الشراء — إدارة" },
      {
        name: "description",
        content: "رفع فيديو شكر عامّ + فيديو خاصّ لكلّ منتج يظهر بعد إتمام الشراء.",
      },
    ],
  }),
});
